import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';

// import InputText from '../../elements/InputText';
// import InputNumber from '../../elements/InputNumber';
// import InputTextArea from '../../elements/InputTextArea';
import InputCheckbox from '../../elements/InputCheckbox';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import RenderErrors from '../../elements/RenderErrors';
import DropDownSelection from '../../elements/DropDownSelection';

//import ContactListModal from '../../modals/ContactListModal';
import VendorModal from '../../modals/VendorModal';
import AddressBookModal from '../../modals/AddressBookModal';
import ProductFinderModal from '../../modals/ProductFinderModal';
import initTreeView from '../../../services/initTreeView';

import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { Button } from 'primereact/button';

import ProfileContext from '../../../services/profileContext';
         

export default function PaymentMadeForm (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');

    const { payment_made_id } = useParams();
    const { bill_id } = useParams();
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New Payment Record');
    const [record_loaded, setRecordLoaded] = useState(0);
    const [bill_data, setBillData] = useState([]);
    const [form_data, setFormData] = useState(store.payment_maid_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [vendor_modal, setVendorModal] = useState(0);
    const [paid_amount, setAmountPaid] = useState(0);
    const [extra_amount, setExtraAmount] = useState(0);
    const [is_full_payment, setFullPayment] = useState(0);
    const [el_paid_amount, setElAmountReceived] = useState([]);
    
   
    useEffect(() => {
        initTreeView()
        //const payment_made_id = helpers.getURLParams('BillID') ?? ''

        if(bill_id){
            setPageTitle('Bill Payment Record')
            getBill(bill_id)
        }
        else if(payment_made_id){
            setPageTitle('Payment Made Details')
            fetchData(payment_made_id)
        }
        else{
            getEnums()
        }
    }, []);

    useEffect(() => {
        if(el_paid_amount){
            confirmApplyToAll(el_paid_amount)
        }
    }, [el_paid_amount]);

    useEffect(() => {
        displayTableItems()
        computeAppliedAmount();
        computeExtraAmount();
    }, [record_items]);

    useEffect(() => {
        if(form_data.paid_amount){
            computeAppliedAmount()
            computeExtraAmount()
        }
    }, [form_data.paid_amount]);

    useEffect(() => {
        let total_balance = 0

        if(is_full_payment){
            Object.entries(record_items).map(([key, data]) => {
                total_balance = parseFloat(total_balance) + parseFloat(data.balance_amount)

                data['payment'] = parseFloat(data.balance_amount)
                let items = [...record_items]
                items[key] = data
                setRecordItems(items)
            });
        }
        else{
            Object.entries(record_items).map(([key, data]) => {
                data['payment'] = 0
                let items = [...record_items]
                items[key] = data
                setRecordItems(items)
            });
        }

        if(!total_balance) total_balance = null;

        let new_state = { "paid_amount" : total_balance }
        setFormData({ ...form_data, ...new_state });

        displayTableItems()
    }, [is_full_payment]);

    function fetchData(payment_made_id){
        if(!payment_made_id){
            return
        }
        const url = helpers.createUrl('V1/manage/payment-makes/'+payment_made_id+'?store_id='+helpers.getStoreID())
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            
            let data = res;
            data.payment_date = new Date(res.payment_date)

            setLoading(0)
            setRecordLoaded(1)
            setFormData(data)
            setRecordItems(data.items)
            getEnums()
        })
        .catch((err) => {
            setLoading(0)
            getEnums()
            setRecordLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    //return navigate("/item/list");
                    window.location.replace("/payment-made/list");
                }
            })
        }); 

    }

    function getBill(bill_id){
        if(!bill_id){
            return
        }
        const url = helpers.createUrl('V1/manage/bills/'+bill_id+'?store_id='+helpers.getStoreID())
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            const balance_amount = parseFloat(res.balance_amount)
            if(balance_amount <= 0){
                window.location.replace(`/bills/${bill_id}`);
            }

            setLoading(0)
            setRecordLoaded(1)
            getEnums()
            setBillData(res)

            let data = {...form_data}
            data.vendor_id = res.vendor_id ?? ''
            data.vendor_name = res.vendor_name ?? ''

            setFormData(data)
    
            let new_item = []
            new_item.push({
                "id": "",
                "bill_id": res.id,
                "bill_date": res.bill_date,
                "bill_no": res.bill_no,
                "total_amount": res.total_amount,
                "balance_amount": res.balance_amount,
                "payment": 0,
                "balance_amount": res.balance_amount
            })
            setRecordItems(new_item)
        })
        .catch((err) => {
            setLoading(0)
            getEnums()
            setRecordLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace(`/bills/${bill_id}/form`);
                }
            })
        }); 

    }

    function computeAppliedAmount(){
        let total_amount = 0
        Object.entries(record_items).map(([key, data]) => {
            if(data.payment){
                total_amount = total_amount + parseFloat(data.payment)
            }
        });

        setAmountPaid(helpers.formatCurrencyAmount(total_amount, default_currency))
        return total_amount;
    }

    function computeExtraAmount(){
        let paid_amount = form_data.paid_amount ?? 0
        let extra_amount = 0

        extra_amount = parseFloat(paid_amount) - computeAppliedAmount()

        setExtraAmount(helpers.formatCurrencyAmount(extra_amount, default_currency))
    }

    function displayTableItems(){
        let table_items = []
        
        if (record_items.length) {
            table_items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>{data.bill_date ? helpers.formatDate(data.bill_date) : '---'}</td>
                    <td>{data.bill_no ? data.bill_no : '---'}</td>
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                    <td>{helpers.formatCurrencyAmount(data.balance_amount, default_currency)}</td>
                    <td>
                        <InputNumber 
                            name="payment" 
                            value={parseFloat(data.payment)} 
                            id="payment" 
                            onValueChange={(e) => inputItemChange(e, key)} 
                            //mode="currency" 
                            //currency="PHP"
                            minFractionDigits={2}
                            min={0}
                            max={parseFloat(data.due_amount)}
                        />
                    </td>
                </tr>)

            })
        }

        setTableItems(table_items)
    }

    function getEnums(){
        setLoading(1)

        const url = helpers.createUrl('V1/enums/orders'+'?only=payment_methods&store_id='+helpers.getStoreID())
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setEnums(res)
            setLoading(0)
        })
        .catch((err) => {
            setLoading(0)
        }); 
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if(name==='is_full_payment'){
            if (is_full_payment) {
                value = false;
            } else {
                value = true;
            }

            setFullPayment(!is_full_payment)
            return;
        }

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        } 

        if(name === 'paid_amount'){
            if(value && !bill_id){
                setElAmountReceived(e)
            }
            else{
                let items = [...record_items]
                let target = {...record_items[0]}
                target['payment'] = value
                items[0] = target
                setRecordItems(items)
            }
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }
    function inputItemChange(e, key) {
        let { value, name } = e.target;
        
        if(isNaN(parseFloat(value))){
            value = 0
        }

        let items = [...record_items]
        let target = {...record_items[key]}

        target[name] = value

        items[key] = target

        setRecordItems(items)
    }

    function handleVendor(e){
        let data = {...form_data}

        data.vendor_id = e.id ?? ''
        data.vendor_name = e.vendor_name ?? ''

        setFormData(data)

        if(e.bills.length){
            const bills = e.bills;
            let new_item = []
            new_item = Object.entries(bills).map(([key, data]) => {
                    return ({
                            "id": "",
                            "bill_id": data.id,
                            "bill_date": data.bill_date,
                            "bill_no": data.bill_no,
                            "total_amount": data.total_amount,
                            "balance_amount": data.balance_amount,
                            "payment": 0,
                            "balance_amount": data.balance_amount
                    })
            })

            setRecordItems(new_item)
        }
    }

    function submit(e, status = ''){
        e.preventDefault()
        //setLoading(1)

        let url = helpers.createUrl('V1/manage/payment-makes/create')
        if(payment_made_id){
            url = helpers.createUrl('V1/manage/payment-makes/' + payment_made_id)
        }

        let formData = {...form_data}
        formData['items'] = record_items;

        httpRequest(url, 'POST', {
            postdata: formData,
        }, true)
            .then((res) => {
                setLoading(0)

                let id = payment_made_id;
                if(!id){
                    id = res.data.id
                }

                let redirect_url = `/payment-made/${id}/edit`
                if(bill_id){
                    redirect_url = `/bills/${bill_id}`
                }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace(redirect_url);
                        return;
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    const confirmApplyToAll = (event) => {
        if(event.originalEvent){
            confirmPopup({
                target: event.originalEvent.target,
                message: 'Would you like this amount to be applied to each payment field?',
                icon: 'pi pi-exclamation-triangle',
                defaultFocus: 'accept',
                accept
            });
        }
    };

    
    const accept  = () => {
        let paid_amount = parseFloat(form_data.paid_amount)

        Object.entries(record_items).map(([key, data]) => {
            if(paid_amount >= parseFloat(data.balance_amount)){
                data['payment'] = parseFloat(data.balance_amount)
                paid_amount = parseFloat(paid_amount) - parseFloat(data.balance_amount)
            }
            else if(paid_amount != 0){
                data['payment'] = parseFloat(paid_amount)
                paid_amount = parseFloat(paid_amount) - parseFloat(data.balance_amount)
            }
            else{
                data['payment'] = 0
            }
            let items = [...record_items]
            items[key] = data
            setRecordItems(items)
        });
    };

    return (
        <>
        <VendorModal 
            is_show={vendor_modal} 
            setShow={setVendorModal} 
            handleSelect={handleVendor} 
        />

        <Layout page_title={page_title} menu="manage-payment-made" breadcrumbs={true} parent_link='/payment-made/list' parent_text="Manage Payment Makes">
                <div className="content">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <form>
                            <div className="row mb-2">
                                <div payment_made_id="so-customer-section" className="col-lg-12">

                                    {form_data.payment_no ?
                                    <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                                        <h5 className='mb-3 mb-md-0 d-flex'>{form_data.payment_no}</h5>
                                        <div className='d-flex flex-column flex-sm-row'>
                                        </div>
                                    </div> : ''}

                                    <div className="card">
                                        <div className="card-body pt-md-5">

                                            {form_data.bill_no ?
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Payment #</label>
                                                </div>
                                                <div className="col-md-3 col-lg-2 form-group">
                                                <input type="text" className="form-control" placeholder="Payment No" value={form_data.bill_no} readOnly />
                                                </div>
                                            </div> : ''}

                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Vendor<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3">
                                                    {/* <div className="input-group">
                                                        {
                                                            record_loaded ? 
                                                            <input type="text" className="form-control" placeholder="Select Vendor" disabled={payment_made_id}  value={form_data.vendor_name}  /> 
                                                            : 
                                                            <input type="text" className="form-control" placeholder="Select Vendor" onClick={(e) => setVendorModal(1)} value={form_data.vendor_name} />
                                                        }
                                                        

                                                        <div className="input-group-append">
                                                            <button className="btn btn-primary" type="button" onClick={(e) => setVendorModal(1)} disabled={record_loaded}><i className="fas fa-search" /></button>
                                                        </div>
                                                    </div> */}
                                                    <div className="p-inputgroup flex-1">
                                                        <InputText 
                                                            placeholder="Select Vendor"
                                                            onClick={(e) => setVendorModal(1)} 
                                                            value={form_data.vendor_name} 
                                                            disabled={payment_made_id ? true : false}
                                                        />
                                                        <Button 
                                                            icon="fas fa-search" 
                                                            className="p-button-primary" 
                                                            type="button"
                                                            onClick={(e) => setVendorModal(1)}
                                                            disabled={payment_made_id ? true : false}
                                                        />
                                                    </div>
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="vendor_name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12"><hr/></div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Payment Date<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Calendar 
                                                        name="payment_date"  
                                                        value={form_data.payment_date} 
                                                        onChange={inputChange} 
                                                        className='w-100' 
                                                        dateFormat="yy-mm-dd" 
                                                        icon={() => <i className="far fa-calendar"></i>} 
                                                        showIcon  
                                                        disabled={!form_data.vendor_name}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="payment_date" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            {
                                            bill_id && record_loaded ?
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Due Balance</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 d-flex form-group">
                                                    <span className='border px-3 py-2 bg-light rounded'>{helpers.formatCurrencyAmount(bill_data.balance_amount)}</span>
                                                </div>
                                            </div> : ''
                                            }

                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Paid Amount<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <div className="p-inputgroup flex-1">
                                                        <span className="p-inputgroup-addon">{default_currency}</span>
                                                        <InputNumber 
                                                            name="paid_amount" 
                                                            value={form_data.paid_amount} 
                                                            id="paid_amount" 
                                                            onValueChange={inputChange} 
                                                            minFractionDigits={2}
                                                            disabled={!form_data.vendor_name || is_full_payment}
                                                        />
                                                    </div>
                                                    <ConfirmPopup dismissable={false} />

                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="paid_amount" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                    {
                                                        bill_id && record_loaded ?
                                                        <RenderErrors 
                                                        errors={errors} 
                                                        name="items" 
                                                        className="text-danger mb-2"
                                                        style={{fontSize: '.9rem'}}
                                                        /> : ''
                                                    }

                                                    {  // For Single Bill Payment
                                                        !record_loaded ?
                                                        <div className="d-flex align-items-center mt-2">
                                                            <Checkbox name="is_full_payment" id="is_full_payment" value={is_full_payment} onChange={inputChange} checked={is_full_payment} 
                                                                disabled={!form_data.vendor_name} />
                                                            <label htmlFor="is_full_payment" className="m-0 ml-2 font-weight-normal">Full amount payment</label>
                                                        </div> : ''
                                                    }

                                                    {
                                                        bill_id ?
                                                        <div className="d-flex align-items-center mt-2">
                                                            <Checkbox name="is_full_payment" id="is_full_payment" value={is_full_payment} onChange={inputChange} checked={is_full_payment} 
                                                                disabled={!form_data.vendor_name} />
                                                            <label htmlFor="is_full_payment" className="m-0 ml-2 font-weight-normal">Full amount payment</label>
                                                        </div> : ''
                                                    }
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Payment Method<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Dropdown  
                                                        name='payment_method_id'
                                                        value={parseInt(form_data.payment_method_id)} 
                                                        onChange={inputChange} 
                                                        options={enums.payment_methods} 
                                                        optionLabel="method_name" 
                                                        optionValue="id" 
                                                        placeholder="Select Payment Method" 
                                                        className="w-100" 
                                                        disabled={!form_data.vendor_name}
                                                        filter
                                                        showClear
                                                     />

                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="payment_method_id" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Reference No</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputText 
                                                        name="reference_no"
                                                        value={form_data.reference_no} 
                                                        onChange={inputChange} 
                                                        className='w-100' 
                                                        disabled={!form_data.vendor_name}  
                                                    />

                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="order_no" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label className={!form_data.vendor_name ? 'text-muted' : ''}>Notes</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                   <InputTextarea 
                                                        name="notes" 
                                                        value={form_data.notes}  
                                                        onChange={inputChange}
                                                        rows={2} 
                                                        cols={30} 
                                                        className='w-100'
                                                        disabled={!form_data.vendor_name}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="notes" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                            !bill_id ?
                            <div payment_made_id="so-item-container mt-5" className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body p-0 table-responsive">
                                            <table className='table mb-0'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th>DATE</th>
                                                        <th>BILL NO</th>
                                                        <th>BILL AMOUNT</th>
                                                        <th width={200}>DUE AMOUNT</th>
                                                        <th width={200}>PAYMENT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {table_items}
                                                    { errors.hasOwnProperty('items') ?
                                                    <tr>
                                                        <td colSpan={6} className='text-center'>
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="items" 
                                                                className="text-danger mb-2"
                                                                style={{fontSize: '.9rem'}}
                                                            />
                                                        </td>
                                                    </tr> : ''}
                                                </tbody>
                                                <tbody className='border-top-0'>
                                                    <tr>
                                                        <td colSpan={4} className='text-right border-right'>Applied Payment Amount</td>
                                                        <td colSpan={1}><b>{paid_amount}</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={4} className='text-right border-right'>Paid Amount</td>
                                                        <td colSpan={1}><b>{helpers.formatCurrencyAmount(form_data.paid_amount)}</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={4} className='text-right border-right'>Extra Amount</td>
                                                        <td colSpan={1}><b>{extra_amount}</b></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> : ""
                            }

                            <div className='text-right mt-3'>     
                                <button type='button' className='btn btn-success mr-3 ' onClick={(e) => submit(e, 5)}>Save</button>

                                {
                                    bill_id ? 
                                    <Link className='btn btn-outline-dark' to={`/bills/${bill_id}`}>Cancel</Link> : 
                                    <Link className='btn btn-outline-dark' to="/payment-made/list">Cancel</Link>
                                }
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
        </>
    )
}